import React, {useEffect, useState} from "react";
import "./UserList.css";
import {translate} from "./Language/Translate";
import {BlackWhite} from "./styledComponents/colors";
import {Table, Row, Col, Button} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import Auth from "../helpers/auth";
import UserEdit from "../newForms2/users/UserEdit";
import {simpleRequest} from "../newForms2/simpleRequest";
import {fetchCompanyFromAPI} from "../actions/currentCompany";
import ConfirmationArea from "../components/ConfirmationArea";
import {isInDevelopment} from "../config";
import UserDeveloperInfo from "./UserDeveloperInfo";
import UserDeveloperCompareInfo from "./UserDeveloperCompareInfo";

const UserDetails = ({user, setView, view}) => {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [invited, setInvited] = useState(false);
  const newObj = {};
  const currentUser = useSelector(st => st.currentUser);
  const currentCompany = useSelector(st => st.currentCompany);
  const dispatch = useDispatch();
  const {mayEdit, mayInvite} = Auth.getCompareAll(currentUser, user);
  // const mayEdit = Auth.mayEdit(currentUser.userStatus, user.userStatus)
  const isCorrectUser = currentUser.username === user.username;
  // const mayInvite = Auth.isAdmin(currentUser.userStatus) || !isCorrectUser;
  ["title", "firstName", "lastName", "email", "phone", "mobile", "note"].forEach(k => (newObj[k] = user[k] || ""));

  const handleInvite = async () => {
    if (invited) return;
    const data = (
      await simpleRequest({url: `emails/invitation`, method: "post", data: {username: user.username, companyId: currentCompany.id}})
    ).data;
    if (!data) {
      setServerError("Fehler beim Senden der Einladung. Bitte versuchen Sie es später noch einmal.");
      setTimeout(() => setServerError(null), 5000);
    } else {
      setInvited(true);
    }
  };
  const Details = () => {
    const nameTxt = `${user.title ? `${user.title} ` : ""}${user.firstName} ${user.lastName}`;

    return (
      <div className="m-1 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
        <h5>{nameTxt}</h5>
        {user.functions ? <h6>{user.functions}</h6> : null}
        {isInDevelopment && <UserDeveloperInfo user={currentUser} companyId={currentCompany.id} />}
        {isInDevelopment && <UserDeveloperInfo user={user} companyId={currentCompany.id} />}
        {isInDevelopment && <UserDeveloperCompareInfo user={currentUser} otherUser={user} />}
        {/* <Table> */}
        {Object.entries(newObj).map(e => (
          <p key={e[0]}>{translate(e[0]) + ": " + e[1]}</p>
        ))}
        {/* </Table> */}
        <Row>
          {mayInvite && !isCorrectUser && (
            <Col>
              <Button block className={`btn btn-${invited ? "secondary" : "info"}`} onClick={handleInvite}>
                {invited ? "Eingeladen" : "Einladungsmail versenden"}
              </Button>
            </Col>
          )}
          {(mayEdit || isCorrectUser) && (
            <Col>
              <Button block className="btn btn-info" onClick={() => setView("form")}>
                {translate("Edit")}
              </Button>
            </Col>
          )}
          {mayEdit && !isCorrectUser && (
            <Col>
              <Button block className="btn btn-danger" onClick={() => setConfirmDelete(true)}>
                {translate("Delete")}
              </Button>
            </Col>
          )}
          <Col>
            <Button block className="btn btn-secondary" onClick={() => setView("list")}>
              {translate("Back")}
            </Button>
          </Col>
        </Row>
        {serverError && (
          <p className="text-danger mt-1">
            <b>{serverError}</b>
          </p>
        )}
        {confirmDelete && <ConfirmationArea handleDelete={handleDelete} handleCancel={() => setConfirmDelete(false)} />}
      </div>
    );
  };
  const handleDelete = async () => {
    const data = await simpleRequest({url: `users/${currentCompany.id}/${user.username}`, method: "delete"});
    console.log({data});
    dispatch(fetchCompanyFromAPI(currentCompany.id));
  };
  return (
    <>
      {view === "details" && <Details />}
      {view === "form" && <UserEdit user={user} setView={setView} />}
    </>
  );
};
export default UserDetails;
